import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from 'material-ui';
import SwitchIcon from '../../../icons/SwitchIcon';
import Dictionary from '../../../model/Dictionary';
import './RoutesSwitchStyles.css';

const RoutesSwitch = ({ selectedRoute, toggleRoutes }) => (
  <div className='row form-group'>
    <div className='form-group route'>
      <label>{Dictionary.flights.from}</label>
      <h1>{selectedRoute.departure}</h1>
    </div>
    <IconButton className='switch-icon'>
      <SwitchIcon
        className='route-switch-icon'
        onClick={() => toggleRoutes(true)}
        {...this.props}
      />
    </IconButton>
    <div className='form-group route'>
      <label>{Dictionary.flights.to}</label>
      <h1>{selectedRoute.arrival}</h1>
    </div>
  </div>
);

RoutesSwitch.propTypes = {
  selectedRoute: PropTypes.object,
  toggleRoutes: PropTypes.func,
};

export default RoutesSwitch;



// WEBPACK FOOTER //
// ./src/components/flights/routesSwitch/RoutesSwitch.js